import MarkedForDesignersModule from './MarkedForDesignersModule'
export default MarkedForDesignersModule
